module.exports = __webpack_public_path__ + "static/media/arrowBm2@4x.baa36db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrowBm2@4x.png
// module id = 232
// module chunks = 0 1